import { render } from "./BrandPortfolioRoasCell.vue?vue&type=template&id=e7cfb6ae&scoped=true"
import script from "./BrandPortfolioRoasCell.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioRoasCell.vue?vue&type=script&lang=js"

import "./BrandPortfolioRoasCell.vue?vue&type=style&index=0&id=e7cfb6ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7cfb6ae"]])

export default __exports__